import { T, LANGUAGES } from "../theme";

export default function LangBadge({ lang }) {
  const cfg = LANGUAGES[lang] || { badge: lang?.toUpperCase() || "?", color: T.bg3 };
  return (
    <span
      style={{
        fontSize: 10,
        fontWeight: 700,
        background: cfg.color,
        color: "#fff",
        borderRadius: 4,
        padding: "1px 5px",
        letterSpacing: 0.5,
      }}
    >
      {cfg.badge}
    </span>
  );
}
